import NodeRequest from "~/ts/library/listen/NodeRequest";
import OperatorCometListener from "~/operatorApplication/ts/service/comet/OperatorCometListener";

export default class OperatorNodeRequest extends NodeRequest {
    constructor(url: string) {
        let listener = OperatorCometListener.get();
        if (!listener) {
            throw new Error("Listener не инициализирован");
        }
        super(listener, url, OperatorCometListener.domainWithProtocol);
    }

    send(waitingForAnswer: boolean = false): Promise<string> {
        return super.send(waitingForAnswer);
    }
}